import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import { Container, Badge } from "reactstrap"
import { Navbar, NavItem, NavLink, Nav } from "reactstrap"
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

import { useShoppingCart } from "use-shopping-cart"
import { AiOutlineShoppingCart } from "react-icons/ai"

import Link from "../../components/link"
import logo from "../../assets/images/artgreetings.png"

const Header = ({}) => {
  const products = useStaticQuery(
    graphql`
      query {
        allContentfulProduct {
          edges {
            node {
              name
              slug
            }
          }
        }
        allContentfulCategory(sort: { fields: name }) {
          edges {
            node {
              name
              slug
            }
          }
        }
      }
    `
  )

  const [isOpen, setIsOpen] = useState(false)
  const allCategories = products.allContentfulCategory.edges

  allCategories.sort((a, b) => a.node.name - b.node.name)

  return (
    <StyledNavbar className="border-bottom navbar-expand" light color="white">
      <Container fluid>
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="Logo" height="40px" />
        </Link>

        <Nav className="ml-auto" navbar>
          <NavItem className="d-none d-md-inline">
            <NavLink tag={Link} to={`/category/poster`}>
              Poster
            </NavLink>
          </NavItem>
          <NavItem className="d-none d-md-inline">
            <NavLink tag={Link} to={`/category/karten`}>
              Alle Karten
            </NavLink>
          </NavItem>
          <NavItem className="d-none d-md-inline">
            <NavLink tag={Link} to={`/category/karten-sets`}>
              Karten-Sets
            </NavLink>
          </NavItem>
          <NavItem className="d-none d-md-inline">
            <NavLink tag={Link} to={`/category/geburtstag`}>
              Geburtstag
            </NavLink>
          </NavItem>
          {/* <NavItem className="d-none d-md-inline">
            <NavLink tag={Link} to={`/category/weihnachten`}>
              Weihnachten
            </NavLink>
          </NavItem> */}

          <UncontrolledDropdown
            nav
            inNavbar
            className="d-none d-md-inline mr-2"
          >
            <DropdownToggle nav>mehr...</DropdownToggle>
            <DropdownMenu right>
              {allCategories
                .filter(
                  ({ node }) =>
                    ![
                      "poster",
                      "poster-oder-kunstdrucke",
                      "karten",
                      "karten-sets",
                      "geburtstag",
                    ].includes(node.slug)
                )
                .map(({ node }, index) => (
                  <DropdownItem key={index}>
                    <NavLink tag={Link} to={`/category/${node.slug}`}>
                      {node.name === "Karten" ? "Alle Karten" : node.name}
                    </NavLink>
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </UncontrolledDropdown>
          <UncontrolledDropdown nav inNavbar className="d-md-none mr-2">
            <DropdownToggle nav>Kategorien</DropdownToggle>
            <DropdownMenu right>
              <DropdownItem>
                <NavLink tag={Link} to={`/category/poster`}>
                  Poster
                </NavLink>
              </DropdownItem>
              <DropdownItem>
                <NavLink tag={Link} to={`/category/karten`}>
                  Alle Karten
                </NavLink>
              </DropdownItem>
              {allCategories
                .filter(
                  ({ node }) =>
                    !["Poster", "poster-oder-kunstdrucke", "karten"].includes(
                      node.slug
                    )
                )
                .map(({ node }, index) => (
                  <DropdownItem key={index}>
                    <NavLink tag={Link} to={`/category/${node.slug}`}>
                      {node.name === "Karten" ? "Alle Karten" : node.name}
                    </NavLink>
                  </DropdownItem>
                ))}
            </DropdownMenu>
          </UncontrolledDropdown>
          <NavItem>
            <ShoppingCart />
          </NavItem>
          {/* <NavItem>
              <NavLink href="https://www.etsy.com/de/shop/ArtGreetingsShop">
                Zum Etsy Shop
              </NavLink>
            </NavItem> */}
        </Nav>
      </Container>
    </StyledNavbar>
  )
}

export default Header

const ShoppingCart = (props) => {
  const { cartCount } = useShoppingCart()
  return (
    <StyledNavLink tag={Link} to="/cart">
      <AiOutlineShoppingCart size={20} />
      <small>
        <Badge color="primary" pill>
          {cartCount}
        </Badge>
      </small>
    </StyledNavLink>
  )
}

const StyledNavLink = styled(NavLink)`
  position: relative;
  padding-right: 1rem !important;
  .badge {
    position: absolute;
    top: 0.25rem;
    right: 0.1rem;
  }
`
const StyledNavbar = styled((props) => <Navbar {...props} />)`
  position: sticky !important;
  top: 0;
  z-index: 1000;
  .nav-link:hover {
    color: ${({ theme }) => theme.primary}!important;
  }
  .dropdown-item:active,
  .dropdown-item:hover {
    background-color: ${({ theme }) => theme.backgroundPrimary};
  }
`
